'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BigLink = undefined;
var _jsxFileName = 'src/payment-pages/notification-page.js';
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _contentWrapper = require('./content-wrapper');
var _contentWrapper2 = _interopRequireDefault(_contentWrapper);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Wrapper = (0, _glamorous2.default)(_contentWrapper2.default)(function (_ref) {
  var theme = _ref.theme;
  return {
    padding: '10rem 0',
    textAlign: 'center'
  };
});
var Title = (0, _glamorous2.default)(_glamorous.H2)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    fontSize: '3rem',
    marginBottom: theme.space_xs,
    marginTop: theme.space_md
  };
});
var secondaryCopyStyles = function secondaryCopyStyles(_ref3) {
  var theme = _ref3.theme,
    fontSize = _ref3.fontSize;
  return {
    color: theme.colorGrey,
    fontSize: fontSize,
    fontWeight: 500,
    lineHeight: 1.2,
    maxWidth: '800px',
    margin: '0 auto'
  };
};
var SecondaryCopy = (0, _glamorous2.default)('p')(secondaryCopyStyles);
var BigLink = exports.BigLink = (0, _glamorous2.default)('a')(function (_ref4) {
  var theme = _ref4.theme;
  return {
    fontSize: '2.8rem'
  };
});
NotificationPage.propTypes = {
  container: _propTypes.bool.isRequired,
  title: _propTypes.string,
  children: _propTypes.node,
  Img: _propTypes.element,
  text: _propTypes.node
};
NotificationPage.defaultProps = {
  title: 'Oh dear :(',
  children: undefined,
  Img: undefined,
  text: undefined
};
function NotificationPage(_ref5) {
  var container = _ref5.container,
    title = _ref5.title,
    children = _ref5.children,
    Img = _ref5.Img,
    text = _ref5.text;
  return _react2.default.createElement(Wrapper, {
    container: container,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47
    },
    __self: this
  }, Img, _react2.default.createElement(Title, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49
    },
    __self: this
  }, title), _react2.default.createElement(SecondaryCopy, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50
    },
    __self: this
  }, text), children);
}
exports.default = NotificationPage;